/** Stable id shared by Pixel, CAPI (event_id), and Amplitude (insert_id). */
export function createEventId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `evt_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}
